<template>
  <div class="col-10 col-md-8 offset-1 offset-md-2">
    <div class="row">
      <div class="d-none d-md-flex col-md-6 p-0">
        <img
          class="w-100 h-100 object-fit-cover"
          src="images/forgot-password.png"
        />
      </div>
      <div class="col-12 col-md-6 p-5 bg-white">
        <p>
          {{ $t("reset.title") }}
        </p>
        <p>{{ $t("reset.change_message") }}</p>
        <b-form-group :label="$t('field.email')">
          <b-form-input
            v-model="$v.form.email.$model"
            :class="{ 'border border-danger': $v.form.email.$error }"
            name="email"
            type="email"
            required
            placeholder="lorem@ipsum.dolor"
          />
          <li class="list-group-item px-0 border-0 py-0">
            <span v-if="!$v.form.email.$error">&nbsp;</span>
            <span
              v-else-if="!$v.form.email.required"
              class="small text-danger"
              >{{ $t("form.required") }}</span
            >
            <span v-else-if="!$v.form.email.email" class="small text-danger">{{
              $t("form.email")
            }}</span>
          </li>
        </b-form-group>
        <b-form-group :label="$t('field.password')">
          <b-form-input
            v-model="$v.form.password.$model"
            :class="{ 'border border-danger': $v.form.password.$error }"
            name="password"
            type="password"
            required
            placeholder="**************"
          />
          <li class="text-danger list-group-item px-0 border-0 py-0">
            <span v-if="!$v.form.password.$error">&nbsp;</span>
            <span
              v-else-if="!$v.form.email.minLength"
              class="small text-danger"
              >{{ $t("form.minLength", { min: 8 }) }}</span
            >
            <span
              v-else-if="!$v.form.password.required"
              class="small text-danger"
              >{{ $t("form.required") }}</span
            >
          </li>
        </b-form-group>
        <b-form-group :label="$t('field.password_confirmation')">
          <b-form-input
            v-model="$v.form.password_confirmation.$model"
            :class="{
              'border border-danger': $v.form.password_confirmation.$error,
            }"
            name="password_confirmation"
            type="password"
            required
            placeholder="**************"
          />
          <li class="text-danger list-group-item px-0 border-0 py-0">
            <span v-if="!$v.form.password_confirmation.$error">&nbsp;</span>
            <span
              v-else-if="!$v.form.password_confirmation.required"
              class="small text-danger"
              >{{ $t("form.required") }}</span
            >
            <span
              v-else-if="!$v.form.password_confirmation.sameAs"
              class="small text-danger"
              >{{
                $t("form.sameAs", {
                  field: this.$t("field.password").toLowerCase(),
                })
              }}</span
            >
          </li>
        </b-form-group>
        <div class="row">
          <div class="col-12 align-items-end justify-content-center d-flex">
            <b-button variant="primary" class="px-5" @click.stop="change">
              {{ $t("reset.change_password") }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required, email, sameAs } from 'vuelidate/lib/validators'
import api from '@/api/users'

export default {
  data: () => ({
    form: {
      email: null,
      password: null,
      password_confirmation: null
    },
    api: api
  }),
  methods: {
    async change() {
      if (this.$v.form.$invalid) {
        this.$toasted.error(this.$t('form.error'))
        return
      }

      try {
        const response = await this.api.resetChangePassword({
          token: this.$route.params.token,
          ...this.form
        })

        if (response && response.data) {
          this.$toasted.success(this.$t('reset.password_changed'))
          this.$router.push({ name: 'login' })
        } else if (
          response &&
          response.response &&
          response.response.data &&
          response.response.data.errors
        ) {
          this.$toasted.error(
            Object.entries(response.response.data.errors)
              .map(item => item[1])
              .join(' ')
          )
        } else if (
          response &&
          response.response &&
          response.response.data &&
          response.response.data.message
        ) {
          this.$toasted.error(this.$t(response.response.data.message))
        } else {
          this.$toasted.error(this.$t('messages.unknown_error'))
        }
      } catch (e) {
        this.$toasted.error(this.$t(e))
      }
    }
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required
      },
      password_confirmation: {
        required,
        sameAsPassword: sameAs('password')
      }
    }
  }
}
</script>
